var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoFidilite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15.99 13.7",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{opacity:0.6;}.cls-2{fill:#ffa000;}.cls-3,.cls-4{fill:none;stroke:#ffa000;stroke-miterlimit:10;}.cls-3{stroke-width:0.8px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.28,2.35a.08.08,0,0,0-.08-.06H12.75s0,0,0,0v0c-.15-.45-.29-.9-.44-1.35v0a.09.09,0,0,0-.08,0,.08.08,0,0,0-.07.05v0c-.14.45-.29.89-.43,1.34,0,0,0,0,0,0H10.22a.07.07,0,0,0-.07.06.08.08,0,0,0,0,.08l0,0,1.12.81,0,0s0,0,0,0h0l-.44,1.35v0a.06.06,0,0,0,0,.08.1.1,0,0,0,.09,0h0l1.15-.84s0,0,.05,0l1.15.84h0a.07.07,0,0,0,.11-.07s0,0,0,0c-.14-.45-.29-.89-.43-1.34,0,0,0,0,0-.06l1.14-.82s0,0,0,0A.08.08,0,0,0,14.28,2.35Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M15.59.71s0,0-.07,0h-.61s0,0-.05,0L14.68.07v0a.09.09,0,0,0-.08,0,.08.08,0,0,0-.07.05v0l-.18.56s0,0,0,0h-.61s-.06,0-.08.06a.07.07,0,0,0,0,.08l0,0,.26.19.22.16s0,0,0,0h0l-.16.5,0,.08a.08.08,0,0,0,0,.09.07.07,0,0,0,.09,0h0l.48-.35,0,0s0,0,0,0l.49.35h0a.07.07,0,0,0,.09,0,.09.09,0,0,0,0-.07v0c-.06-.19-.13-.37-.19-.56,0,0,0,0,0-.05h0l.46-.34,0,0A.1.1,0,0,0,15.59.71Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M14.81,3.92a.08.08,0,0,0,0,0h-.36s0,0,0,0-.07-.22-.11-.33v0a0,0,0,0,0,0,0s0,0,0,0h0c0,.12-.07.23-.11.34s0,0,0,0h-.36a.1.1,0,0,0,0,0s0,0,0,.05h0l.15.11.13.09s0,0,0,0h0l-.1.29a.43.43,0,0,1,0,0,0,0,0,0,0,0,0,.07.07,0,0,0,.06,0h0l.28-.21h0l.28.21h.06a.05.05,0,0,0,0-.05v0l-.11-.33s0,0,0,0h0l.27-.2h0A.11.11,0,0,0,14.81,3.92Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M15.59,13.28H6.09c-.13,0-.17,0-.17-.15,0-1.15,0-2.3,0-3.45A.32.32,0,0,1,6,9.45C6.9,8.38,7.78,7.3,8.67,6.22a.2.2,0,0,1,.19-.08h6.73Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 10.88,
    y: 6.58,
    width: 0.87,
    height: 6.32
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 4.58,
    y: 5.42,
    width: 0.94,
    height: 1.35,
    transform: "translate(-2.87 6.19) rotate(-51.05)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M8.93,3.06,7.36,1.76c-.07-.06-.1-.05-.17,0L5.75,3.53c-.28.33-.61.74-.91,1.11a3.58,3.58,0,0,0-.16-1.32,3.05,3.05,0,0,0-.9-1.39.6.6,0,0,0-1,.38,2.65,2.65,0,0,0,0,1,3.87,3.87,0,0,0,.53,1.29l-.14,0a3.55,3.55,0,0,0-1.25-.23,2.19,2.19,0,0,0-1.2.27.53.53,0,0,0-.14.84,2.06,2.06,0,0,0,1,.62,4,4,0,0,0,2.06.08l-.15.18C2.69,7.26,1.92,8.14,1.18,9c-.05.05-.09.09,0,.16l1.6,1.32c.06.05.08,0,.13,0Q4.12,9,5.36,7.53L6.55,6.1,8.94,3.22C9,3.15,9,3.12,8.93,3.06Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoFidilite);
export default __webpack_public_path__ + "static/media/noFidilite.da5373d2.svg";
export { ForwardRef as ReactComponent };